import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ContactsService } from '../services/contacts.service';
import { Contact } from '../entities/contact.class';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.scss'],
  standalone: false
})
export class ContactsListComponent implements OnInit {
  @Input() canEdit: boolean;
  customerId: string;
  leadId: string;
  contactId: string;
  baseAccountsRoute: any;
  appStrings: AppLocalization;
  loading: boolean;
  contactsList: any[] = [];
  defaultPhotoUrl: string;
  photoUrl;
  photoData = null;
  photoId = null;
  photoUrlList = {};
  dateTimeFormat = this.appInfoService.dateTimeFormat;
  isOnline: boolean;
  dialogOpen$ = new EventEmitter<boolean>();
  dialogButtons = [
    { label: 'Yes', type: 'primary', onclick: this.confirmDelete.bind(this) },
    { label: 'Cancel', type: 'secondary' },
  ];
  dialogTitle: string;
  dialogText: string;
  currentContactId: string;

  constructor(
    private contactsService: ContactsService,
    private activatedRoute: ActivatedRoute,
    private appInfoService: AppInfoService,
    private appStateService: AppStateService,
    private sanitizer: DomSanitizer,
    private router: Router,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.isOnline = this.appStateService.state.isOnline;
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.leadId = this.activatedRoute.snapshot.params['leadId'];
    this.baseAccountsRoute = this.customerId ? '/accounts' : '/accounts-leads';
    this.loading = true;
    const photoUrls = this.contactsService.displayDefaultContactPhoto();
    this.defaultPhotoUrl = photoUrls.defaultPhotoUrl;
    this.photoUrl = photoUrls.photoUrl;
    this.dialogTitle = this.appStrings.contacts_deleteContactTitle;
    this.dialogText = this.appStrings.contacts_deleteContactText;

    // For template values
    this.contactsService.getTemplateValues(() =>
      this.contactsService.getContactsList(this.customerId, this.leadId, result => {
        this.contactsList = result;
        this.loading = false;
        this.contactsList.forEach((contact: Contact) => {
          this.photoUrlList[contact.id] = this.defaultPhotoUrl;

          if (contact.photo) {
            this.contactsService.getPhoto(contact.photo.id).subscribe((data: ArrayBuffer) => {
              const photoBlob = new Blob([new Uint8Array(data, 0, data.byteLength)]);
              this.photoUrlList[contact.id] = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(photoBlob));
            });
          }
        });
      }));
  }

  editContact(contactId: string) {
    this.router.navigate([this.baseAccountsRoute, this.customerId || this.leadId, 'contacts', contactId]);
  }

  deleteContact(contactId: string) {
    this.currentContactId = contactId;
    this.dialogOpen$.emit(true);
  }

  confirmDelete() {
    this.contactsService.deleteContact(this.currentContactId,
      () => this.contactsService.getContactsList(this.customerId, this.leadId, list => this.contactsList = list));
  }

  /**
   * Toggle the expended and collapsed state of notes
   * @param event - The click event
   */
  public toggle(event) {
    event.currentTarget.classList.toggle('collapsed');
  }
}
